// removed by extract-text-webpack-plugin
module.exports = {"block":"tNtf2HVyVXcNoFgNzo89o","links":"_1L75s97kpUOES1K2VxrQKB","link":"_2Ymc4AgVFb1yo4uaIbaF9b","zebra":"_3r1ozrv7ndEyQiv6rDOMFk","yellow":"_33cEQsMuwe460Y4CooP0ms","darkgray":"_2B4LKQ0yNfayklteC4RgiT","bg":"_2ytJpXd2eCsPQIKRPSnpE7","heading":"_3UhqNahc5UsTgts4HmuoZS","active":"YAT6DHqdOBDdeTqjNxJLk","content":"_2zMjdrYoR8VdQF26Ik9TRz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BusinessAreaListBlock/BusinessAreaListBlock.module.scss
// module id = 738
// module chunks = 0